import React, {PropTypes} from 'react';

const FormInput = ({
	className,
  input, 
  placeholder,
  ref,
  type,
  id
}) => (
  <input {...input}
          id={id}
          type={type} 
          className={className} 
          placeholder={placeholder}
          ref={ref}
  />
);

FormInput.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  input: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  ref: PropTypes.string,
  type: PropTypes.string.isRequired
};

export default FormInput;


/** WEBPACK FOOTER **
 ** ./src/modules/common/components/FormInput.js
 **/